import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spinner } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';

import { UploadStatusTypes } from 'constants/EventDocUploadStatuses';
const { Uploading } = UploadStatusTypes;

const backgroundColorMap = {
  Completed: 'rgba(40, 155, 106, 0.1)',
  Failed: 'rgba(222, 47, 27, 0.1)',
  Uploading: 'rgba(0, 149, 255, 0.1)',
};

const colorMap = {
  Completed: '#36B37E',
  Failed: '#DE2F1B',
  Uploading: '#0095FF',
};

const iconMap = {
  Completed: faCheckCircle,
  Failed: faExclamationTriangle,
};

const StatusListItem = styled.div`
  position: relative;
  background-color: ${(props) => backgroundColorMap[props.type]};
  border-top: 1px solid ${(props) => colorMap[props.type]};
  padding: 16px;
`;

const StatusListIcon = styled.span`
  position: absolute;
  right: 16px;
`;

const StatusListItemName = styled.span`
  display: inline-block;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const getStatusLabel = (type, message) => {
  if (message) return message;
  if (type) return type;
  return '';
};

function FSObjectUploadStatusListItem({ status, fileName }) {
  const { message, type } = status;
  const faIcon = iconMap[type];

  return (
    <StatusListItem {...{ type }}>
      <StatusListItemName>{fileName}</StatusListItemName>
      <StatusListIcon>
        {type === Uploading ? (
          <Spinner size="sm" color="primary" />
        ) : (
          <>
            <span>{getStatusLabel(type, message)}</span>
            <FontAwesomeIcon icon={faIcon} color={colorMap[type]} />
          </>
        )}
      </StatusListIcon>
    </StatusListItem>
  );
}

FSObjectUploadStatusListItem.propTypes = {
  status: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default FSObjectUploadStatusListItem;
